import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const DeleteIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    {...props}
  >
    <Path d="M2.18179 2.93182L2.18182 16.75H13.8182L13.8182 2.93182M0 2.93182H5.81818M16 2.93182H10.1818M10.1818 2.93182L10.1819 0.75H5.81818V2.93182M10.1818 2.93182H5.81818M5.81818 6.56818V13.1136M10.1818 6.56818V13.1136" stroke={color} strokeWidth="1.5" />
  </Svg>
);

DeleteIcon.displayName = 'DeleteIcon';
